import { getDefinition } from "./catalog";
import type { ComponentDefinition, SystemNode } from "./types";

export type ChargeAdviceBasis = "manufacturer-recommended" | "catalog-planning" | "declared" | "chemistry-estimate";

/** Maxima take precedence. Recommendations and assumptions never become limits,
 * including when a catalog definition is copied into an imported custom part. */
export function chargeAdviceBasis(node: SystemNode | undefined, def: ComponentDefinition): ChargeAdviceBasis {
  if (def.maxChargeA != null) return "declared";
  if (def.recommendedChargeA != null) {
    const canonical = node?.kind === "component" && node.definitionId !== "custom" && !node.customDefinition &&
      node.definitionId === def.id && def === getDefinition(node.definitionId);
    return canonical ? "manufacturer-recommended" : "catalog-planning";
  }
  if (def.chargePlanningA != null) return "catalog-planning";
  return "chemistry-estimate";
}

/** Charger-method currents are deliberately excluded from universal thresholds. */
export function chargeAdviceThreshold(def: ComponentDefinition): number {
  return def.maxChargeA ?? def.recommendedChargeA ?? def.chargePlanningA ??
    (def.capacityAh ?? 0) * (def.chemistry === "lifepo4" ? 0.5 : 0.3);
}
